import type { Result } from './result.js';

const format = /^(19|20)?([0-9]{2}[01][0-9][0-3][0-9])-?([0-9]{4})$/;

/**
 * Handles Swedish social security numbers for people born between 1900 and 2099 (inclusive).
 */
export class SocialSecurityNumber {
  private id: string;
  private constructor(id: string) {
    const match = id.match(format);
    if (match === null) {
      throw new Error('Invalid string for social security number: ' + id);
    }

    let firstGroup = match[1];
    const secondGroup = match[2];
    const thirdGroup = match[3];
    if (firstGroup === undefined) {
      const tentativeYear = parseInt('19' + secondGroup.slice(0, 2), 10);
      const currentYear = new Date().getFullYear();
      firstGroup = currentYear - tentativeYear >= 100 ? '20' : '19';
    }

    this.id = firstGroup + secondGroup + thirdGroup;
  }

  public static fromString(id: string): Result<SocialSecurityNumber> {
    try {
      return new SocialSecurityNumber(id);
    } catch (e) {
      return new Error(e as string);
    }
  }

  public static fromStringUnsafe(id: string) {
    return new SocialSecurityNumber(id);
  }

  public display() {
    return this.id.slice(0, 8) + '-' + this.id.slice(8);
  }

  /**
   * Returns a social security number in the format YYYYMMDDXXXX.
   */
  public toString(): string {
    return this.id;
  }
}
